import * as React from "react";
import { Layout } from "react-admin";
import MyAppBar from "./MyAppBar";
import { MySidebar } from "./MySidebar";
import ChatbotWidget from "./ChatbotWidget";

export const MyLayout = (props) => {
  const [open, setOpen] = React.useState(true);

  const toggleDrawer = () => {
    setOpen((prev) => !prev);
  };

  // Keep current values in refs so the stable component wrappers
  // always read the latest state without needing to be re-created.
  const openRef = React.useRef(open);
  const toggleDrawerRef = React.useRef(toggleDrawer);
  openRef.current = open;
  toggleDrawerRef.current = toggleDrawer;

  // Create stable component references so react-admin's Layout does not
  // unmount/remount the sidebar on every render. Inline arrow functions
  // create a new component type each render, which causes React to
  // destroy and recreate the entire subtree — resetting scroll position.
  const StableSidebar = React.useMemo(
    () =>
      function StableSidebarInner(sidebarProps) {
        return (
          <MySidebar
            {...sidebarProps}
            open={openRef.current}
            toggleDrawer={toggleDrawerRef.current}
          />
        );
      },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const StableAppBar = React.useMemo(
    () =>
      // eslint-disable-next-line react/display-name
      function StableAppBarInner(appBarProps) {
        return (
          <MyAppBar
            {...appBarProps}
            open={openRef.current}
            toggleDrawer={toggleDrawerRef.current}
          />
        );
      },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <>
      <Layout
        {...props}
        appBar={StableAppBar}
        sidebar={StableSidebar}
      />
      <ChatbotWidget />
    </>
  );
};


